import { Injectable } from '@angular/core';
import { SplittableDynamicComponentConfig } from '../model/splittable-dynamic-component-config';

@Injectable({
  providedIn: 'root'
})
export class SplitComponentService {
  private splitComponents = new Map<string, SplittableDynamicComponentConfig<any>[]>();

  public initSplitter(id: string): void {
    if (!this.splitComponents.has(id)) {
      this.splitComponents.set(id, []);
    } else {
      throw 'Key existing';
    }
  }

  public destroySplitter(id: string): void {
    if (this.splitComponents.has(id)) {
      this.splitComponents.delete(id);
    }
  }

  public getComponentsConfigs(id: string): SplittableDynamicComponentConfig<any>[] {
    return this.splitComponents.get(id);
  }

  public addComponent<T>(id: string, componentConfig: SplittableDynamicComponentConfig<T>): void {
    let dynamicComponents = this.splitComponents.get(id);

    const index = dynamicComponents.findIndex(dc => dc.id === componentConfig.id);

    if (index > -1) {
      dynamicComponents[index] = componentConfig;
      dynamicComponents = [...dynamicComponents];
    } else {
      dynamicComponents = [...dynamicComponents, componentConfig];
    }

    this.splitComponents.set(id, dynamicComponents.sort((left, right) => left.id - right.id));
  }

  public removeComponent(splitId: string, componentId: number): void {
    const dynamicComponents = this.splitComponents.get(splitId);

    const index = dynamicComponents.findIndex(dc => dc.id === componentId);

    if (index > -1) {
      dynamicComponents.splice(index, 1);

      this.splitComponents.set(splitId, [...dynamicComponents]);
    }
  }
}
